import type { RouteConfig } from 'vue-router';

export default [
  /**
   * 广告投放落地页
   */
  {
    path: '/lp/001',
    meta: {
      excludeLogin: true,
    },
    component: () => import('@/views/channel/promotion/001/index.vue'),
  },
  /**
   * 广告投放落地页002
   */
  {
    path: '/lp/002',
    meta: {
      excludeLogin: true,
    },
    component: () => import('@/views/channel/promotion/002/index.vue'),
  },
  /**
   * 新版投放落地页
   */
  // {
  //   path: '/lp/003',
  //   meta: {
  //     excludeLogin: true,
  //     background: '#F62E22',
  //   },
  //   component: () => import('@/views/channel/promotion/003/index.vue'),
  // },
  // /**
  //  * 新版投放落地页对应下载页
  //  */
  // {
  //   path: '/lp/003/download-app',
  //   meta: {
  //     excludeLogin: true,
  //     background: '#FFF8EF',
  //   },
  //   component: () => import('@/views/channel/promotion/003/download-app.vue'),
  // },
  // /**
  //  * 新版投放落地页004
  //  */
  // {
  //   path: '/lp/004',
  //   meta: {
  //     excludeLogin: true,
  //     background: '#F62E22',
  //   },
  //   component: () => import('@/views/channel/promotion/004/index.vue'),
  // },
  // /**
  //  * 新版投放落地页004对应下载页
  //  */
  // {
  //   path: '/lp/004/download-app',
  //   meta: {
  //     excludeLogin: true,
  //     background: '#FFF8EF',
  //   },
  //   component: () => import('@/views/channel/promotion/004/download-app.vue'),
  // },
  // /**
  //  * 新版投放落地页005
  //  */
  // {
  //   path: '/lp/005',
  //   meta: {
  //     excludeLogin: true,
  //     background: '#F62E22',
  //   },
  //   component: () => import('@/views/channel/promotion/005/index.vue'),
  // },
  // /**
  //  * 新版投放落地页对应下载页
  //  */
  // {
  //   path: '/lp/005/download-app',
  //   meta: {
  //     excludeLogin: true,
  //     background: '#FFF8EF',
  //   },
  //   component: () => import('@/views/channel/promotion/005/download-app.vue'),
  // },
  // /**
  //  * 新版投放落地页006
  //  */
  // {
  //   path: '/lp/006',
  //   meta: {
  //     excludeLogin: true,
  //     excludeTracking: true,
  //     background: '#ffffff',
  //   },
  //   component: () => import('@/views/channel/promotion/006/index.vue'),
  // },
  // /**
  //  * 新版投放落地页006对应下载页
  //  */
  // {
  //   path: '/lp/006/download-app',
  //   meta: {
  //     excludeLogin: true,
  //     excludeTracking: true,
  //     background: '#ffffff',
  //   },
  //   component: () => import('@/views/channel/promotion/006/download-app.vue'),
  // },
  // /**
  //  * 新版投放落地页007
  //  */
  // {
  //   path: '/lp/007',
  //   meta: {
  //     excludeLogin: true,
  //     excludeTracking: true,
  //     background: '#F5F6F7',
  //   },
  //   component: () => import('@/views/channel/promotion/007/index.vue'),
  // },
  // /**
  //  * 新版投放落地页007对应下载页
  //  */
  // {
  //   path: '/lp/007/download-app',
  //   meta: {
  //     excludeLogin: true,
  //     excludeTracking: true,
  //     background: '#f5f6f7',
  //   },
  //   component: () => import('@/views/channel/promotion/007/download-app.vue'),
  // },
  // /**
  //  * 新版投放落地页008
  //  */
  // {
  //   path: '/lp/008',
  //   meta: {
  //     excludeLogin: true,
  //     excludeTracking: true,
  //     background: '#F5F6F7',
  //   },
  //   component: () => import('@/views/channel/promotion/008/index.vue'),
  // },
  // /**
  //  * 新版投放落地页008对应下载页
  //  */
  // {
  //   path: '/lp/008/download-app',
  //   meta: {
  //     excludeLogin: true,
  //     excludeTracking: true,
  //     background: '#f5f6f7',
  //   },
  //   component: () => import('@/views/channel/promotion/008/download-app.vue'),
  // },
  // /**
  //  * 新版投放落地页009
  //  */
  // {
  //   path: '/lp/009',
  //   meta: {
  //     excludeLogin: true,
  //     excludeTracking: true,
  //     background: '#F5F6F7',
  //   },
  //   component: () => import('@/views/channel/promotion/009/index.vue'),
  // },
  // /**
  //  * 新版投放落地页009对应下载页
  //  */
  // {
  //   path: '/lp/009/download-app',
  //   meta: {
  //     excludeLogin: true,
  //     excludeTracking: true,
  //     background: '#f5f6f7',
  //   },
  //   component: () => import('@/views/channel/promotion/009/download-app.vue'),
  // },
  // /**
  //  * 新版投放落地页010
  //  */
  // {
  //   path: '/lp/010',
  //   meta: {
  //     excludeLogin: true,
  //     excludeTracking: true,
  //     background: '#F5F6F7',
  //   },
  //   component: () => import('@/views/channel/promotion/010/index.vue'),
  // },
  // /**
  //  * 新版投放落地页010对应下载页
  //  */
  // {
  //   path: '/lp/010/download-app',
  //   meta: {
  //     excludeLogin: true,
  //     excludeTracking: true,
  //     background: '#f5f6f7',
  //   },
  //   component: () => import('@/views/channel/promotion/010/download-app.vue'),
  // },
  // /*
  //  * 新版投放落地页011
  //  */
  // {
  //   path: '/lp/011',
  //   meta: {
  //     excludeLogin: true,
  //     excludeTracking: true,
  //     background: '#EDF2FF',
  //   },
  //   component: () => import('@/views/channel/promotion/011/index.vue'),
  // },
  // /**
  //  * 新版投放落地页011对应下载页
  //  */
  // {
  //   path: '/lp/011/download-app',
  //   meta: {
  //     excludeLogin: true,
  //     excludeTracking: true,
  //     background: '#EDF2FF',
  //   },
  //   component: () => import('@/views/channel/promotion/011/download-app.vue'),
  // },
  // /**
  //  * 新版投放落地页012
  //  */
  // {
  //   path: '/lp/012',
  //   meta: {
  //     excludeLogin: true,
  //     excludeTracking: true,
  //     background: '#F5F6F7',
  //   },
  //   component: () => import('@/views/channel/promotion/012/index.vue'),
  // },
  // /**
  //  * 新版投放落地页010对应下载页
  //  */
  // {
  //   path: '/lp/012/download-app',
  //   meta: {
  //     excludeLogin: true,
  //     excludeTracking: true,
  //     background: '#f5f6f7',
  //   },
  //   component: () => import('@/views/channel/promotion/012/download-app.vue'),
  // },
  /**
   * 投放落地页分发
   */
  {
    path: '/lp',
    meta: {
      excludeLogin: true,
    },
    component: () => import('@/views/channel/promotion/dispatcher.vue'),
  },
] as RouteConfig[];
